import type { VRPilotGuideRouteTarget } from './VRPilotGuide.types';

export const getVRPilotGuideRouteUrl = (
  step: VRPilotGuideRouteTarget & { path: string }
) => {
  const params = new URLSearchParams();

  Object.entries(step.query ?? {}).forEach(([key, value]) => {
    if (value !== null) params.set(key, value);
  });

  const search = params.toString();

  return search ? `${step.path}?${search}` : step.path;
};

export const matchesVRPilotGuideRoute = (
  target: VRPilotGuideRouteTarget,
  location: { pathname: string; search: string }
) => {
  if (
    target.path &&
    location.pathname !== target.path &&
    (target.path === '/' || !location.pathname.startsWith(`${target.path}/`))
  ) {
    return false;
  }

  const currentParams = new URLSearchParams(location.search);
  const matchesQuery = Object.entries(target.query ?? {}).every(
    ([key, value]) => currentParams.get(key) === value
  );
  const matchesExcludedQuery = Object.entries(target.queryExclude ?? {}).some(
    ([key, value]) => currentParams.get(key) === value
  );

  return matchesQuery && !matchesExcludedQuery;
};
